function useTableProperties(data) {
    return {
        count: data.count || 0,
        data: data.rows || [],
        total: data.totalPages,
    };
}
export default useTableProperties;
